import React from 'react';
import { render } from 'react-dom';
import { initOnIntersection } from 'utilities/dom';

import { checkIfVideoAPIReady, videoOptions, VideoPlayer } from 'features/youtube';

import InspireHomeDecorCarousel from '../../../../apps/inspireHomeDecorCarousel/desktop/InspireHomeDecorCarousel';
import dynamicImport from '../../../../features/webpack/dynamicImport.macro';

function initInspireHomeDecor () {

	let cleanupIntersection = [];
	let player;
	const { apiSettings, aspectRatio } = videoOptions;
	const ui = {
		videoThumbnails: document.querySelectorAll('.inspire-me-video-thumb')
	};
	const tipsWidgetElement = document.getElementById('tipsWidgetElement');
	const pixleeElement = document.getElementById('pixleeWidget');
	const marker = document.getElementById('pixleeWidgetHomeScrollMarker');
	const pixleeWidgetShowNextPrevButtonHomePageToggleOn = JSON.parse(
		window.lp.globals.pixleeWidgetShowNextPrevButtonHomePageToggleOn
	);

	if (pixleeElement) {

		cleanupIntersection = initOnIntersection(
			marker,
			() => {

				dynamicImport('desktop/sort-inspireHomeDecor-pixleeInstagramFeed', './pixleeInstagramFeed').then(
					(module) => {

						const initinspireHomeDecorInstagramFeed = module.default;
						initinspireHomeDecorInstagramFeed(
							pixleeElement,
							pixleeWidgetShowNextPrevButtonHomePageToggleOn
						);

					}
				);

			},
			'0px 0px 300px 0px'
		);

	}

	const utils = {
		getDynamicVideoWidth () {

			return document.documentElement.clientWidth <= 1000 ? 700 : 900;

		},
		getDynamicVideoHeight () {

			const screenHeight = document.documentElement.clientHeight;

			if (screenHeight <= 600) {

				return 500;

			}
			if (screenHeight <= 800) {

				return 600;

			}
			if (screenHeight <= 1000) {

				return 700;

			}
			return 900;

		},
		getPlayerDimensions () {

			return {
				width: utils.getDynamicVideoWidth(),
				height: utils.getDynamicVideoHeight() * aspectRatio
			};

		},
		getModalVideoContent () {

			return '<div id="player"></div>';

		}
	};

	const handlers = {
		videoThumbnailClick: (e) => {

			const videoId = e.currentTarget.dataset.videoid;

			const { width, height } = utils.getPlayerDimensions();

			if (videoId) {

				$('body').lpModal({
					onInit: true,
					lpModalClass: 'lpModal--alt1 lpModal--noScroll',
					content: $(utils.getModalVideoContent()),
					width,
					height,
					openEvt: () => {

						checkIfVideoAPIReady().then(() => {

							// initialize player when modal opens
							player = VideoPlayer('player', {
								width,
								height,
								videoId,
								playerVars: apiSettings
							});

						});

					},
					closeEvt: () => {

						// destroy player when modal closes
						player.destroy();
						player = null;

					}
				});

			}

		}
	};

	if (ui.videoThumbnails.length) {

		ui.videoThumbnails.forEach((videoThumbnail) => {

			videoThumbnail.addEventListener('click', handlers.videoThumbnailClick);
			videoThumbnail.addEventListener('keydown', (e) => {

				if (e.which === 13) {

					handlers.videoThumbnailClick.call(e.target, e);

				}

			});

		});

	}

	render(
		<InspireHomeDecorCarousel showShopNextPrevButtonToggleOn={pixleeWidgetShowNextPrevButtonHomePageToggleOn} />,
		tipsWidgetElement
	);

	// animated scroll
	function sortScrollTo (target) {

		const element = document.getElementById(target);
		element.scrollIntoView({ behavior: 'smooth' });

	}

	const scrollButton = document.querySelector('.shopTheCollectionBtn');

	if (scrollButton) {

		scrollButton.addEventListener('click', (e) => {

			e.preventDefault();
			sortScrollTo('sortFilterWrapper');

		});

	}

	return cleanupIntersection;

}

export default initInspireHomeDecor;
